<div class="dish-picture" [class.dish-picture__default]="selectedMediaSrc === mediaDefaultSrc">
  <input
    #uploadFile
    style="display: none;"
    type="file"
    accept=".mp4,.jpg,.jpeg,.png"
    (change)="changeVideo($event)"
  >

  <button
    [disabled]="!allowOverrides"
    type="button"
    (click)="uploadFile.click()"
    class="dish-imgbtn"
  >
  <div>
    <div *ngIf="!selectedMediaSrc" style="display: flex; justify-content: center;">{{ 'MENU.ADD_MEDIA' | translate }}</div>
    <video
      *ngIf="selectedMediaSrc && isVideo(getMediaTypeByUrl(selectedMediaSrc))"
      [src]="selectedMediaSrc"
      class="dish-img"
    ></video>
    <img
      *ngIf="selectedMediaSrc  && !isVideo(getMediaTypeByUrl(selectedMediaSrc))"
      [src]="selectedMediaSrc"
      class="dish-img"
    />
  </div>
  </button>

  <div class="dish-picture-buttons" *ngIf="allowOverrides">
    <div
      class="dish-picture__delete"
      *ngIf="selectedMediaSrc !== mediaDefaultSrc"
      (click)="deleteDishVideo()"
    >
      <mat-icon>delete_outline</mat-icon>
    </div>
  </div>
</div>
